// React
import React from "react";
import PropTypes from "prop-types";
// Framework
import { usePortal } from "stack/core";
import { useStackDependency } from "stack/dependency";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const ActivityProvider = ({ options, children }) => {
  // Framework
  const { activity } = usePortal();
  // Init
  useStackDependency(activity, options);
  // Render
  return <>{children}</>;
};

ActivityProvider.propTypes = {
  options: PropTypes.object,
};

export { ActivityProvider };
